import axios from "axios";

const newRequest = axios.create({
  baseURL: "https://bima-essentials.com/api",
  withCredentials: true,
  // timeout: 20000, // Global timeout of 20 seconds
});

// ✅ Global response interceptor for handling timeout or other errors
// newRequest.interceptors.response.use(
//   (response) => response, // Pass through success responses
//   (error) => {
//     if (error.code === 'ECONNABORTED') {
//       console.error("⏱ Global Interceptor: Request timed out");
//     } else {
//       console.error("🚨 Global Interceptor: Error", error.message);
//     }
//     return Promise.reject(error); // Always re-throw error
//   }
// );

export default newRequest;
